import { MultiselectOptionWithSensorType } from '@Types/multiselect.types';
import { ValuemappingProfileFormShape } from '@Types/valuemappingForm.types';
import {
	CreateValuemappingProfileRequest,
	Override,
} from '@Types/valuemappingManager.types';
import { createValuemappingProfileCreateRequest } from './valuemappingFormHelpers';

const determineMessagesBasedOnSensors = (
	sensors: MultiselectOptionWithSensorType[],
	appliesTo: CreateValuemappingProfileRequest['appliesTo'],
	overridesTypes: string,
	overridesSensors: string,
) => {
	const overrideTypesMessages: Set<string> = new Set();
	const overrideIdsOrAliasMessages: Set<string> = new Set();

	appliesTo.forEach(({ type: formType, field: formField }) => {
		if (formType === 'sensor_type') {
			if (overridesTypes.includes(formField)) {
				overrideTypesMessages.add(formField); // ? typeInFormExistsInPreviouslyCreatedProfiles
			} else {
				overridesTypes.split(',').forEach(overrideType => {
					overrideIdsOrAliasMessages.add(overrideType);
				});
			}
		}
		if (formType === 'sensor_id') {
			const sensorFullInfo = sensors.find(({ id }) => id === formField);
			if (
				overridesSensors.split(', ').includes(formField) &&
				sensorFullInfo?.value
			) {
				overrideIdsOrAliasMessages.add(sensorFullInfo.value); // ? idInFormExistsInPreviouslyCreatedProfiles (will add alias or id)
			} else if (
				sensorFullInfo &&
				overridesTypes.includes(sensorFullInfo.sensorType)
			) {
				overrideIdsOrAliasMessages.add(sensorFullInfo.sensorType); // ? typeOfSensorInFormExistsInPreviouslyCreatedProfiles
			} else {
				overridesSensors.split(', ').forEach(overrideSensor => {
					const foundSensor = sensors.find(
						({ id }) => id === overrideSensor,
					);
					if (foundSensor?.value) {
						overrideIdsOrAliasMessages.add(foundSensor.value);
					}
				});
			}
		}
	});

	return {
		type: overrideTypesMessages,
		idOrAlias: overrideIdsOrAliasMessages,
	};
};

export const determineOverridesMessage = (
	overrides: Override[],
	sensorOptions: MultiselectOptionWithSensorType[],
	values?: ValuemappingProfileFormShape,
): string[] => {
	const messages: string[] = [];

	if (!values) {
		return messages;
	}

	const { appliesTo } = createValuemappingProfileCreateRequest(values);

	overrides.forEach(({ name, types, sensors }) => {
		const sensorMessages = determineMessagesBasedOnSensors(
			sensorOptions,
			appliesTo,
			types,
			sensors,
		);
		if (sensorMessages.type.size || sensorMessages.idOrAlias.size) {
			const elements = new Set([
				...Array.from(sensorMessages.type),
				...Array.from(sensorMessages.idOrAlias),
			]);
			messages.push(
				`${Array.from(elements)
					.filter(el => !!el)
					.join(', ')} - Profile "${name}"`,
			);
		}
	});

	return messages;
};
